import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id/")({
  staticData: {
    title: "projects.title",
  },
  loader: ({ params }) =>
    redirect({
      to: "/sources/projects/$id/general",
      params: { id: params.id },
      replace: true,
    }),
});
